import { Elevations as PaperElevations } from '@/components/Paper/Paper.constants'

export const GROUP_NAME = 'toolbar'

export enum Orientations {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export const DEFAULT_ORIENTATION = Orientations.Horizontal

export const DEFAULT_ELEVATION = PaperElevations.Elevated
